import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagGA(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURQKjY/7WJT15yUWA0kyI2v/ZMP7TGwWqaAevbAiybqCqtp0AAAEYSURBVDjLvYq9coMwEISvUxsVqPaYF/AgPYBn4AFC4T5qqNXh0p1DlxLeNns6fkw8Vig8fNKtdk9LQ5of+rfQ9WDoB7xdNwxr7fsbfafZULje7217hU7TjogPBLss25gE8Tdq0wQpqLVgjxNjIAoYpQJg5ZEsO3gkRYyiIKMmB6Lw3ypOBEW7cEnzuUchA/WFb1azxDAuEFDQdcajawxW+mGB1Qex1ZpHdHERFNJsKPgRbbT3BjJfDzUoGKHhb+8b46NrxPsvakbM/PgpslkKL3hHoUpz3qNQVg5HtHJzGm95JmdL6yxraW0pr4uGrzuRtchCaZ+JhRQbCgXIX3OgPD8WAox4/oCP+UTHFfljKDCHP4Un3lD4BXZsfUbChS9yAAAAAElFTkSuQmCC",
    alt: "GA"
  }, props));
}